document.addEventListener('DOMContentLoaded', function () {
  function enhanceSortSelect(select) {
    if (select.dataset.fcEnhanced) return;
    select.dataset.fcEnhanced = 'true';

    var selectWrap = select.closest('.select');
    var field = selectWrap.parentElement;

    var dropdown = document.createElement('div');
    dropdown.className = 'fc-sort-dropdown';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fc-sort-dropdown__button';

    var label = document.createElement('span');
    label.className = 'fc-sort-dropdown__label';
    label.textContent = select.options[select.selectedIndex].text;

    var caret = document.createElement('span');
    caret.className = 'fc-sort-dropdown__caret';
    caret.innerHTML = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';

    button.appendChild(label);
    button.appendChild(caret);

    var list = document.createElement('div');
    list.className = 'fc-sort-dropdown__list';

    Array.prototype.forEach.call(select.options, function (opt) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'fc-sort-dropdown__item' + (opt.selected ? ' is-selected' : '');
      item.textContent = opt.text;

      item.addEventListener('click', function () {
        select.value = opt.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        dropdown.classList.remove('is-open');
      });

      list.appendChild(item);
    });

    button.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.classList.toggle('is-open');
    });

    dropdown.appendChild(button);
    dropdown.appendChild(list);

    selectWrap.style.display = 'none';
    field.appendChild(dropdown);
  }

  function enhanceAll() {
    document.querySelectorAll('.fc-collection .facet-filters__sort').forEach(enhanceSortSelect);
  }

  document.addEventListener('click', function () {
    document.querySelectorAll('.fc-sort-dropdown.is-open').forEach(function (d) {
      d.classList.remove('is-open');
    });
  });

  enhanceAll();

  /*
    FIX: sistemul nativ de filtrare AJAX al Dawn (facets.js) re-generează
    complet <select>-ul original de fiecare dată când alegi o sortare,
    ștergând dropdown-ul nostru custom construit peste el. Un
    MutationObserver detectează acel moment și reconstruiește imediat
    dropdown-ul nostru peste noul <select>, fără reload de pagină.
  */
  var observer = new MutationObserver(function () {
    enhanceAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});